import { useEffect, useState } from 'react'
import { obtener } from '@/servicios/api'
import { Seleccion } from '@/componentes/ui'

interface Opcion {
  cod: string
  nombre: string
}

export interface ValorGeo {
  codEstado?: string
  codMunicipio?: string
  codParroquia?: string
}

/** Cascada estado → municipio → parroquia con códigos oficiales DPT/INE. */
export function GeoCascada({ valor, onCambio }: { valor: ValorGeo; onCambio: (v: ValorGeo) => void }) {
  const [estados, setEstados] = useState<Opcion[]>([])
  const [municipios, setMunicipios] = useState<Opcion[]>([])
  const [parroquias, setParroquias] = useState<Opcion[]>([])

  useEffect(() => {
    obtener<Opcion[]>('/catalogos/estados').then(setEstados)
  }, [])

  useEffect(() => {
    if (!valor.codEstado) return setMunicipios([])
    obtener<Opcion[]>(`/catalogos/estados/${valor.codEstado}/municipios`).then(setMunicipios)
  }, [valor.codEstado])

  useEffect(() => {
    if (!valor.codMunicipio) return setParroquias([])
    obtener<Opcion[]>(`/catalogos/municipios/${valor.codMunicipio}/parroquias`).then(setParroquias)
  }, [valor.codMunicipio])

  return (
    <div className="grid gap-3 sm:grid-cols-3">
      <Seleccion
        aria-label="Estado"
        value={valor.codEstado ?? ''}
        onChange={(e) => onCambio({ codEstado: e.target.value || undefined, codMunicipio: undefined, codParroquia: undefined })}
      >
        <option value="">Estado…</option>
        {estados.map((e) => (
          <option key={e.cod} value={e.cod}>
            {e.nombre}
          </option>
        ))}
      </Seleccion>
      <Seleccion
        aria-label="Municipio"
        value={valor.codMunicipio ?? ''}
        disabled={!valor.codEstado}
        onChange={(e) => onCambio({ ...valor, codMunicipio: e.target.value || undefined, codParroquia: undefined })}
      >
        <option value="">Municipio…</option>
        {municipios.map((m) => (
          <option key={m.cod} value={m.cod}>
            {m.nombre}
          </option>
        ))}
      </Seleccion>
      <Seleccion
        aria-label="Parroquia"
        value={valor.codParroquia ?? ''}
        disabled={!valor.codMunicipio}
        onChange={(e) => onCambio({ ...valor, codParroquia: e.target.value || undefined })}
      >
        <option value="">Parroquia…</option>
        {parroquias.map((p) => (
          <option key={p.cod} value={p.cod}>
            {p.nombre}
          </option>
        ))}
      </Seleccion>
    </div>
  )
}
